<template>
  <el-card shadow="always" v-if="state == 'CHANGED'">
    <div slot="header" class="clearfix">
      <span>Remetente</span>
    </div>
    <div>
      <el-form ref="form" :model="ruleForm" :label-position="labelPosition" label-width="120px">
        <el-form-item class="no-margin-bottom" :label="$t('remetente')" prop="sender">
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <SenderList ref="senderList" v-model="ruleForm.sender" :customer="customer" v-on:clear="clear" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" label="Nome" :required="true">
              <el-input maxlength="50" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" label="Telefone" :required="true">
              <el-input v-mask="['(##) ####-####', '(##) #####-####']" v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" :label="$t('cep')" prop="cep" :required="true">
              <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" v-loading="loading"
                @blur="zipcode()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('endereco')" prop="address" class="no-margin-bottom" :required="true">
              <el-input maxlength="50" v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
            <el-form-item :label="$t('bairro')" prop="neighborhood" class="no-margin-bottom" :required="true">
              <el-input v-model="ruleForm.neighborhood" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <el-form-item class="no-margin-bottom" :label="$t('cidade')" prop="city" :required="true">
              <el-input v-model="ruleForm.city" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
            <el-form-item class="no-margin-bottom" :label="$t('estado')" prop="state" :required="true">
              <el-input v-model="ruleForm.state" maxlength="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="6">
            <el-form-item class="no-margin-bottom" label="Número" :required="true">
              <el-input v-model="ruleForm.number" maxlength="5"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="18">
            <el-form-item class="no-margin-bottom" label="Complemento">
              <el-input maxlength="30" v-model="ruleForm.extent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="bottom clearfix">
          <el-button class="right" type="primary" @click="confirm()">Confirmar</el-button>
        </div>
      </el-form>
    </div>
  </el-card>
  <el-card v-else shadow="always" style="min-height: 143px">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <label style="font-weight: bold">Remetente:</label>&nbsp;
        <label>{{ ruleForm.contact }}</label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="6" :xl="6">
        <label style="font-weight: bold">CEP:</label>&nbsp;
        <label>{{ ruleForm.cep }}</label>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <label style="font-weight: bold">Endereço:</label>&nbsp;
        <label>{{ ruleForm.address }} - {{ ruleForm.number }}</label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
        <label style="font-weight: bold">Bairro:</label>&nbsp;
        <label>{{ ruleForm.neighborhood }}</label>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <label style="font-weight: bold">Cidade:</label>&nbsp;
        <label>{{ ruleForm.city }} - {{ ruleForm.state }} </label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
        <label style="font-weight: bold">Complemento:</label>&nbsp;
        <label>{{ ruleForm.extent }} </label>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-button type="info" @click="changed" size="mini">Alterar</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { CustomerService } from "@/services/customers/customers.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { SendersService } from "@/services/senders/senders.services";
import FederalId from "@/xpost/components/FederalId";
import SenderList from "@/xpost/views/register/sender/SenderList";
import Vue from "vue";

export default {
  name: "MotoboySender",
  components: {
    FederalId,
    SenderList,
  },
  props: ["customer", "labelPosition", "userName", "state"],
  methods: {
    changed() {
      this.$emit("changed");
    },
    confirm() {
      this.$emit("confirm");
    },
    fetchSender() {
      const vm = this;
      if (!vm.ruleForm.sender) {
        return false;
      }
      SendersService.get(vm.ruleForm.sender)
        .then((response) => {
          vm.ruleForm.cep = response.zipcode;
          vm.ruleForm.name = response.name;
          vm.ruleForm.address = response.address;
          vm.ruleForm.neighborhood = response.neighborhood;
          vm.ruleForm.city = response.city;
          vm.ruleForm.federalId = response.federalId;
          vm.ruleForm.state = response.state;
          vm.ruleForm.number = response.number;
          vm.ruleForm.extent = response.complement;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    zipcode: function () {
      const vm = this;
      if (!vm.ruleForm.cep) {
        return false;
      }
      const loading = vm.$loading(vm.$options.loading);
      PostOfficeService.zipcode(vm.ruleForm.cep)
        .then((response) => {
          vm.ruleForm.address = response.end;
          vm.ruleForm.city = response.cidade;
          vm.ruleForm.state = response.uf;
          vm.ruleForm.neighborhood = response.bairro;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    validate() {
      const vm = this;
      return (
        vm.ruleForm.cep &&
        vm.ruleForm.address &&
        vm.ruleForm.neighborhood &&
        vm.ruleForm.city &&
        vm.ruleForm.state &&
        vm.ruleForm.name &&
        vm.ruleForm.number
      );
    },
    fetchCustomer() {
      const vm = this;
      if (!vm.$props.customer) {
        return false;
      }
      CustomerService.get(vm.$props.customer)
        .then((response) => {
          if (response.cardpost && response.cardpost.length == 0) {
            this.$message({
              type: "warning",
              message: "Cliente sem cartão de postagem relacionado!",
              duration: 5000,
            });
          }
          setTimeout(() => {
            vm.ruleForm.cep = response.zipcode.zipcode;
          }, 300);
          vm.ruleForm.federalId = response.federalid;
          vm.ruleForm.address = response.zipcode.address;
          vm.ruleForm.neighborhood = response.zipcode.neighborhood;
          vm.ruleForm.city = response.zipcode.city;
          vm.ruleForm.state = response.zipcode.state;
          vm.ruleForm.number = response.number;
          vm.ruleForm.extent = response.extent;
          Vue.set(vm.ruleForm, "cep", response.zipcode.zipcode);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    clear() {
      const vm = this;
      vm.ruleForm.cep = "";
      vm.ruleForm.name = "";
      vm.ruleForm.address = "";
      vm.ruleForm.neighborhood = "";
      vm.ruleForm.city = "";
      vm.ruleForm.state = "";
      vm.ruleForm.number = "";
      vm.ruleForm.extent = "";
      vm.ruleForm.federalId = "";
      vm.fetchCustomer();
    },
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchCustomer();
    },
    userName: function (v) {
      const vm = this;
      vm.ruleForm.name = vm.userName || '';
    },
    "ruleForm.sender": function (newVal, oldVal) {
      const vm = this;
      vm.fetchSender();
    },
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        sender: '',
        cep: "",
        federalId: "",
        name: "",
        phone: "",
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        extent: "",
      },
    };
  },
};
</script>
